/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-comment-textnodes */
import { DownOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Dropdown, Space } from "antd";
import { isMobileOnly, isTablet } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { HamburgerIcon } from "src/assets/icons";
import useAuth from "src/hooks/useAuth";
import { ELanguage, PATH_URL } from "src/interfaces";
import { updateLanguage } from "src/utils/changLanguage";
import { NafutelMarketLogo, NafutelReserveLogo } from "../logo";
import "./header.scss";

interface IProps {
  isTopPage?: boolean;
}

function HeaderResaleComponent({ isTopPage = false }: IProps) {
  const { auth, logout, setShowPopupLogin }: any = useAuth();
  const { t } = useTranslation();
  const changeLanguage = () => {
    const currentLanguage = localStorage.getItem("lang");
    const newLanguage =
      currentLanguage === ELanguage.EN ? ELanguage.JA : ELanguage.EN;
    updateLanguage(newLanguage);
    window.location.reload();
  };

  const items: MenuProps["items"] = [
    {
      label: (
        <Link
          style={{ textDecoration: "none" }}
          to={"/authed/hotel/my-page?mypage_tab_active=0"}
        >
          {t("header.resale.link.mypage.item1")}
        </Link>
      ),
      key: "0",
    },
    {
      label: (
        <Link
          style={{ textDecoration: "none" }}
          to={"/authed/hotel/my-page?mypage_tab_active=1"}
        >
          {t("header.resale.link.mypage.item2")}
        </Link>
      ),
      key: "1",
    },
    {
      label: (
        <Link
          style={{ textDecoration: "none" }}
          to={"/authed/hotel/my-page?mypage_tab_active=2"}
        >
          {t("header.resale.link.mypage.item3")}
        </Link>
      ),
      key: "2",
    },
    {
      label: (
        <span onClick={() => logout()}>
          {t("header.resale.link.mypage.item4")}
        </span>
      ),
      key: "3",
    },
  ];

  return (
    <div
      className={` ${
        isTablet ? "HeaderSallerProfileStyleTablet" : "HeaderSallerProfileStyle"
      }  ${isTopPage ? "header-top-page" : ""}`}
    >
      <div
        className={`wrap ${isMobileOnly ? "ps-3" : "px-10"}`}
        style={isTablet ? { padding: "0 6% 0 9%" } : {}}
      >
        <header className="d-flex flex-wrap align-items-center justify-content-between">
          <NafutelMarketLogo isLink />
          <div className="d-none d-sm-block">
            <ul className="nav nav-pills ">
              {auth?.user ? (
                <>
                  <li className="nav-item">
                    <Link className="nav-link text-menu" to="/">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.2422 2.38281H1.75781C0.789766 2.38281 0 3.17172 0 4.14062V15.8594C0 16.825 0.78625 17.6172 1.75781 17.6172H18.2422C19.2078 17.6172 20 16.8309 20 15.8594V4.14062C20 3.175 19.2138 2.38281 18.2422 2.38281ZM17.9995 3.55469L10.0373 11.5169L2.00621 3.55469H17.9995ZM1.17188 15.6167V4.3777L6.81559 9.97301L1.17188 15.6167ZM2.00051 16.4453L7.64777 10.798L9.62656 12.7598C9.85563 12.987 10.2253 12.9862 10.4534 12.758L12.3828 10.8286L17.9995 16.4453H2.00051ZM18.8281 15.6167L13.2114 10L18.8281 4.38328V15.6167Z"
                          fill="white"
                        />
                      </svg>

                      {t("header.resale.link.menu.item1")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-menu" to="/">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_1235_3028)">
                          <path
                            d="M8 15.1099C7.77222 15.1099 7.55261 15.0273 7.38147 14.8774C6.73511 14.3123 6.11194 13.7811 5.56213 13.3126L5.55933 13.3102C3.94739 11.9365 2.55542 10.7502 1.58691 9.58167C0.504272 8.27527 0 7.03662 0 5.68347C0 4.36877 0.450806 3.15588 1.26929 2.26807C2.09753 1.36975 3.23401 0.875 4.46973 0.875C5.39331 0.875 6.23914 1.16699 6.98364 1.7428C7.35938 2.03345 7.69995 2.38916 8 2.80408C8.30017 2.38916 8.64062 2.03345 9.01648 1.7428C9.76099 1.16699 10.6068 0.875 11.5304 0.875C12.766 0.875 13.9026 1.36975 14.7308 2.26807C15.5493 3.15588 16 4.36877 16 5.68347C16 7.03662 15.4958 8.27527 14.4132 9.58154C13.4447 10.7502 12.0529 11.9364 10.4412 13.3099C9.89038 13.7792 9.26624 14.3112 8.61841 14.8777C8.44739 15.0273 8.22766 15.1099 8 15.1099ZM4.46973 1.81226C3.4989 1.81226 2.60706 2.19971 1.95825 2.90332C1.2998 3.61755 0.937134 4.60486 0.937134 5.68347C0.937134 6.82153 1.36011 7.83936 2.30847 8.98364C3.2251 10.0897 4.5885 11.2516 6.16711 12.5969L6.17004 12.5994C6.72192 13.0697 7.34753 13.6029 7.99866 14.1722C8.65369 13.6018 9.28027 13.0677 9.83325 12.5967C11.4117 11.2513 12.775 10.0897 13.6917 8.98364C14.6399 7.83936 15.0629 6.82153 15.0629 5.68347C15.0629 4.60486 14.7002 3.61755 14.0417 2.90332C13.3931 2.19971 12.5011 1.81226 11.5304 1.81226C10.8192 1.81226 10.1663 2.03833 9.58972 2.48413C9.07593 2.88159 8.71802 3.38403 8.50818 3.7356C8.40027 3.91638 8.21033 4.02429 8 4.02429C7.78967 4.02429 7.59973 3.91638 7.49182 3.7356C7.2821 3.38403 6.92419 2.88159 6.41028 2.48413C5.83374 2.03833 5.18079 1.81226 4.46973 1.81226Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1235_3028">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      {t("header.resale.link.menu.item2")}
                    </Link>
                  </li>
                  <li className="nav-item text-menu">
                    <Link className="nav-link text-menu" to="/">
                      {t("header.resale.link.menu.item3")}
                    </Link>
                  </li>
                </>
              ) : null}

              <li className="nav-item text-menu">
                {auth?.user ? (
                  <Dropdown menu={{ items }}>
                    <a
                      href="#"
                      onClick={(e) => e.preventDefault()}
                      style={{ padding: "8px 0 8px 16px" }}
                    >
                      <Space>
                        {t("header.resale.link.menu.item4")}
                        <div style={{ marginTop: -10 }}>
                          <DownOutlined style={{ fontSize: 10 }} />
                        </div>
                      </Space>
                    </a>
                  </Dropdown>
                ) : (
                  <div className="d-none d-sm-block">
                    <ul className="nav nav-pills ">
                      <div className="dropdown">
                        <Link
                          to={`${PATH_URL.RESALE_MY_PAGE}`}
                          className="dropbtn text-menu"
                          style={{ textDecoration: "none" }}
                        >
                          {t("toppage.header.reservation.mypage")}
                        </Link>
                      </div>
                      <li className="nav-item">
                        <span
                          className="nav-link text-menu"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            auth.user ? logout() : setShowPopupLogin(true)
                          }
                        >
                          {auth.user
                            ? t("toppage.header.reservation.logout")
                            : t("toppage.header.reservation.login")}
                          <svg
                            width="21"
                            height="22"
                            viewBox="0 0 21 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-8px", marginLeft: "8px" }}
                          >
                            <path
                              d="M20.275 19.7237H18.4194H13.9637H8.60051H3.94131C3.19258 19.7237 2.43164 19.679 1.68698 19.7237H1.65443L2.33805 20.4073C2.33805 19.329 2.33398 18.2507 2.33805 17.1723V17.0259C2.34212 16.8387 2.40316 16.6067 2.51303 16.4236C2.54558 16.3707 2.57813 16.3138 2.61883 16.2649C2.53744 16.3789 2.65952 16.2242 2.67173 16.2161C2.71242 16.1713 2.75718 16.1307 2.81008 16.094C2.69614 16.1835 2.85484 16.0696 2.87111 16.0615C2.88332 16.0533 3.06644 15.9638 2.92401 16.0249C2.97284 16.0004 3.02981 15.9841 3.08271 15.9638C3.20886 15.9191 3.33907 15.8661 3.46521 15.8214C4.51913 15.447 5.59746 15.1459 6.69614 14.9262C7.97793 14.6698 9.19461 14.5396 10.5334 14.5111C11.2495 14.4989 11.9617 14.5152 12.6738 14.5722C13.3533 14.621 13.8986 14.6902 14.5334 14.7959C15.6443 14.9831 16.7429 15.2517 17.8131 15.5976C18.041 15.6708 18.2689 15.7482 18.4927 15.8295C18.6025 15.8661 18.7083 15.9068 18.8182 15.9475C18.867 15.9638 18.924 15.9882 18.9728 16.0086C19.042 16.0371 19.042 16.0371 18.9728 16.0086C19.0095 16.0249 19.0461 16.0452 19.0786 16.0696C19.0908 16.0777 19.2536 16.1917 19.1397 16.1022C19.1844 16.1388 19.2292 16.1835 19.278 16.2242C19.2862 16.2324 19.4164 16.387 19.3269 16.2731C19.3635 16.3219 19.4001 16.3789 19.4286 16.4318C19.5344 16.6149 19.5914 16.8468 19.5954 17.034C19.632 18.1612 19.5954 19.2883 19.5954 20.4155C19.5954 20.7695 19.9088 21.1154 20.279 21.0991C20.6493 21.0828 20.9627 20.798 20.9627 20.4155C20.9627 19.3209 20.9667 18.2263 20.9627 17.1276C20.9586 16.6067 20.8325 16.0696 20.5395 15.6342C20.3482 15.3453 20.1122 15.1011 19.8192 14.914C19.5873 14.7634 19.3106 14.678 19.0502 14.5803C17.9922 14.1937 16.9098 13.8844 15.8111 13.6525C12.9708 13.0543 10.0532 12.9974 7.19258 13.4572C5.99217 13.6485 4.80804 13.9414 3.6524 14.3199C3.14782 14.4826 2.54965 14.6332 2.10204 14.9303C1.56084 15.2965 1.16613 15.8702 1.03999 16.5131C0.926049 17.095 0.974879 17.7217 0.974879 18.3117V20.2853V20.4114C0.974879 20.7817 1.28821 21.095 1.6585 21.095H3.50998H7.96572H13.3289H17.9881C18.7409 21.095 19.4978 21.1195 20.2424 21.095H20.275C20.629 21.095 20.9749 20.7817 20.9586 20.4114C20.9423 20.0411 20.6616 19.7237 20.275 19.7237Z"
                              fill="white"
                            />
                            <path
                              d="M14.8264 6.45818C14.8264 6.5884 14.8223 6.72675 14.8142 6.86103C14.8101 6.92614 14.8019 6.99124 14.7979 7.05635C14.7816 7.26795 14.8101 6.97904 14.7938 7.10111C14.7572 7.34526 14.7084 7.58941 14.6351 7.82136C14.5985 7.94343 14.5619 8.06144 14.5171 8.17944C14.4927 8.24048 14.4723 8.29745 14.4479 8.35442C14.4968 8.23641 14.4439 8.36256 14.4316 8.39104C14.334 8.60671 14.2201 8.81017 14.0939 9.00955C14.0288 9.11128 13.9556 9.20894 13.8904 9.31067C13.7765 9.46937 13.9759 9.21301 13.8498 9.3595C13.8172 9.39613 13.7847 9.43682 13.7521 9.47344C13.6015 9.64842 13.4428 9.80711 13.2679 9.95767C13.2231 9.9943 13.1783 10.035 13.1295 10.0716C13.2475 9.97395 13.097 10.096 13.0807 10.1082C12.9952 10.1733 12.9016 10.2303 12.8121 10.2873C12.7226 10.3402 12.629 10.3971 12.5354 10.446C12.4866 10.4745 12.4296 10.4989 12.3808 10.5233C12.336 10.5477 12.218 10.5925 12.332 10.5477C12.1204 10.6291 11.9088 10.6983 11.689 10.7471C11.5832 10.7715 11.4734 10.7919 11.3716 10.8081C11.5344 10.7837 11.3391 10.8081 11.3187 10.8122C11.2577 10.8163 11.2007 10.8203 11.1397 10.8244C11.0176 10.8285 10.8996 10.8285 10.7735 10.8244C10.7124 10.8203 10.6555 10.8203 10.5944 10.8122C10.5944 10.8122 10.4032 10.7959 10.509 10.8041C10.6148 10.8162 10.4235 10.7919 10.4235 10.7919C10.3625 10.7837 10.3096 10.7674 10.2485 10.7552C10.1346 10.7267 10.0207 10.7023 9.90673 10.6657C9.79279 10.6291 9.68292 10.5925 9.57713 10.5477C9.72362 10.6087 9.54457 10.5355 9.5283 10.5233C9.48354 10.4989 9.44284 10.4826 9.39808 10.4582C9.19869 10.3565 9.00744 10.2384 8.82433 10.1082C8.80805 10.096 8.65749 9.97798 8.7755 10.0716C8.73074 10.035 8.68597 9.99836 8.63715 9.95767C8.55576 9.88443 8.47845 9.81118 8.40113 9.73794C8.32381 9.66062 8.25057 9.58331 8.17733 9.50193C8.13664 9.45716 8.10001 9.4124 8.06339 9.36357C7.9576 9.24557 8.10815 9.43275 8.0227 9.31474C7.88435 9.12349 7.7582 8.93224 7.64834 8.72878C7.59544 8.62705 7.54253 8.52939 7.49371 8.42766C7.48964 8.41545 7.40826 8.22827 7.46115 8.36256C7.43674 8.30152 7.41639 8.24455 7.39198 8.18758C7.31059 7.95971 7.24142 7.72776 7.18851 7.48768C7.16003 7.37375 7.14376 7.25574 7.12341 7.13773C7.08679 6.92614 7.13155 7.27609 7.11527 7.06042C7.11121 6.99531 7.10307 6.93021 7.099 6.8651C7.08272 6.60874 7.08272 6.34831 7.099 6.09602C7.10307 6.04313 7.10713 5.98616 7.11121 5.93326C7.11121 5.92105 7.13969 5.70538 7.11527 5.85594C7.13155 5.7298 7.15597 5.59959 7.18445 5.47344C7.29839 4.94445 7.42046 4.61485 7.63206 4.22827C7.74193 4.02482 7.86807 3.82543 8.00642 3.63417C8.0227 3.60569 8.11222 3.50396 8.03084 3.60569C8.06746 3.56093 8.10815 3.51617 8.14478 3.46734C8.22209 3.37782 8.30347 3.28829 8.38486 3.20284C8.46624 3.12146 8.55169 3.04007 8.64529 2.96276C8.69004 2.92614 8.7348 2.88545 8.78364 2.84882C8.67783 2.93428 8.77956 2.84882 8.80805 2.83255C8.99117 2.7064 9.17834 2.58026 9.37773 2.47853C9.42657 2.45004 9.48354 2.42563 9.53236 2.40121C9.54864 2.39308 9.72768 2.31983 9.58119 2.3768C9.68292 2.33611 9.78059 2.29948 9.88232 2.26693C10.098 2.19776 10.3218 2.14893 10.5415 2.11637C10.3788 2.14079 10.5741 2.11637 10.5944 2.1123C10.6555 2.10823 10.7124 2.10416 10.7735 2.1001C10.8833 2.09603 10.9973 2.09603 11.1071 2.1001C11.217 2.10416 11.3269 2.1123 11.4367 2.12451C11.274 2.10823 11.4652 2.12858 11.4896 2.13265C11.5507 2.14079 11.6036 2.15706 11.6646 2.16927C11.7948 2.19776 11.9291 2.23438 12.0593 2.27914C12.1122 2.29542 12.1692 2.31576 12.2221 2.34018C12.2384 2.34425 12.4174 2.42156 12.275 2.35645C12.5069 2.45818 12.7307 2.58026 12.9423 2.71454C12.9912 2.74709 13.04 2.77965 13.0888 2.81627C13.1214 2.84068 13.1539 2.86103 13.1865 2.88545C13.1254 2.84068 13.1254 2.84068 13.1865 2.88951C13.276 2.96683 13.3655 3.04414 13.451 3.12146C13.5405 3.21098 13.6341 3.30457 13.7195 3.39816C13.7521 3.43478 13.7847 3.47141 13.8172 3.5121C13.8457 3.54465 13.866 3.57721 13.8945 3.60162C13.8498 3.54058 13.8498 3.54058 13.8986 3.60569C14.0532 3.82136 14.1956 4.04516 14.3177 4.2771C14.3788 4.38697 14.4276 4.50091 14.4764 4.61078C14.4154 4.47242 14.4927 4.66368 14.5049 4.67995C14.5375 4.75727 14.5659 4.83865 14.5863 4.91596C14.6717 5.18046 14.7409 5.44903 14.7816 5.72166C14.7897 5.76235 14.7938 5.80711 14.7979 5.84781C14.7816 5.70538 14.806 5.96581 14.8101 5.9943C14.8223 6.14892 14.8264 6.30355 14.8264 6.45818C14.8264 6.8122 15.1397 7.15808 15.51 7.1418C15.8803 7.12553 16.1936 6.84068 16.1936 6.45818C16.1814 4.15096 14.8955 1.94547 12.7226 1.06246C11.7297 0.655538 10.5659 0.614846 9.5405 0.936311C8.45403 1.27405 7.55474 1.96581 6.87519 2.86917C5.47133 4.72878 5.35739 7.39409 6.4642 9.42461C7.55067 11.4063 9.78465 12.5742 12.0227 12.0818C14.216 11.5976 15.8111 9.57924 16.1163 7.41037C16.161 7.09704 16.1895 6.78778 16.1936 6.46632C16.1936 6.1123 15.8803 5.76642 15.51 5.7827C15.1356 5.79491 14.8304 6.07568 14.8264 6.45818Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                      </li>
                      <div className="dash-header "></div>
                      <li
                        onClick={() => {
                          changeLanguage();
                        }}
                        style={{ cursor: "pointer" }}
                        className="nav-item text-menu "
                      >
                        EN/JP
                      </li>
                    </ul>
                  </div>
                  // <span
                  //   style={{ cursor: "pointer" }}
                  //   onClick={() => setShowPopupLogin(true)}
                  // >
                  //   Log In
                  // </span>
                )}
              </li>
              <NafutelReserveLogo styles={{ marginLeft: "15px" }} isLink />
            </ul>
          </div>

          <div
            className="dropdown d-block d-sm-none"
            style={{ marginRight: 0 }}
          >
            <button className="dropbtn text-menu">
              <HamburgerIcon
                width="32px"
                fill="white"
                stroke="white"
                className=""
              />
            </button>

            <div className="dropdown-content end-0">
              <Link className="nav-link" to={`${PATH_URL.RESERVATION_MY_PAGE}`}>
                My page
              </Link>
              <Link className="nav-link" to="">
                Link 2
              </Link>
            </div>
          </div>
        </header>
      </div>
      <div className="dash"></div>
    </div>
  );
}

export default HeaderResaleComponent;
